// extracted by mini-css-extract-plugin
module.exports = {"active":"AnalyticsSectionItem_active__6hLAx","item":"AnalyticsSectionItem_item__1Klrj"};